import { render, staticRenderFns } from "./UnitAmenities.vue?vue&type=template&id=4797cdba&scoped=true&"
import script from "./UnitAmenities.vue?vue&type=script&lang=js&"
export * from "./UnitAmenities.vue?vue&type=script&lang=js&"
import style0 from "./UnitAmenities.vue?vue&type=style&index=0&id=4797cdba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4797cdba",
  null
  
)

export default component.exports